import React from "react";
import styles from "./previous-games.module.css";
import GameCard from "components/game-card";
import { useTranslation } from "react-i18next";

const PreviousGames = ({ games, team_id }) => {
  const { t } = useTranslation();

  if (games.length < 2) games.push({ team_id }); // Fill with a fake game to have a minimum of 2 games

  return (
    <div className={styles["games-wrapper"]}>
      <div className={`${styles["games-header"]} mb-12`}>
        <h4 className="title-3">{t("dashboard.previous-games.title")}</h4>
      </div>
      <div className={styles["games-cards"]}>
        {games.map((game, index) => (
          <React.Fragment key={index}>
            <GameCard game={game} team_id={team_id} />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default PreviousGames;
